export default __webpack_public_path__ + "static/media/con_chassis01.1b7d203c.jpg";